import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { GasColor } from '../../core/colors/color.namespace';
import { GasInputBoolean } from '@cikrf/gas-utils/decorators';
import { GasMathHelper } from '@cikrf/gas-utils/helpers';

import { GasIcon } from '../../utils/gas-icons/icon/gas-icon.namespace';
import { GasAccordionSectionDirective } from '../gas-accordion/gas-accordion-section.directive';
import { GasSectionType } from './gas-section.interface';

@Component({
  selector: 'gas-section, li[gasAccordionItem]',
  templateUrl: './gas-section.component.html',
  styleUrls: ['./gas-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasSectionComponent {
  /** текущее состояние (открыт/закрыт) */
  @HostBinding('class._active')
  @GasInputBoolean()
  @Input()
  public open: string | boolean = false;

  /** Эмитит значение open секции при клике */
  @Output()
  public openChange: EventEmitter<boolean> = new EventEmitter(this.open as boolean);

  /** тип секции */
  @Input()
  public type: GasSectionType = 'default';

  /** название секции */
  @Input()
  public title: string;

  /** отображение иконки */
  @GasInputBoolean()
  @Input()
  public suffixIcon: string | boolean = false;

  /** имя иконки в конце заголовка */
  @Input()
  public postfixIconName: string | GasIcon.Icons;

  /** Эмитит уникальное значение name секции при клике на иконку */
  @Output()
  public postfixIconClicked: EventEmitter<string> = new EventEmitter<string>();

  /** имя иконки */
  @Input()
  public iconName: string = GasIcon.Common.Lightning;

  /** цвет иконки suffix*/
  @Input()
  public iconColor: GasColor.Color = GasColor.Color.Black;

  /** цвет иконки postfix */
  @Input()
  public postfixIconColor: GasColor.Color = GasColor.Color.Black;

  /** состояние неактивности */
  @HostBinding('class._disabled')
  @GasInputBoolean()
  @Input()
  public disabled: string | boolean = false;

  /** Id секции */
  @Input()
  public nativeId: string = GasMathHelper.getUniqueId();

  /** секция аккордиона */
  @Input()
  public section: GasAccordionSectionDirective;

  public arrowIconColor: GasColor.Color = GasColor.Color.Brand;

  /**
   * TODO: установка arrowIconColor внутри геттера dynamicClass неочевидна + тоже просится Record
   * и константы
   */
  public get dynamicClass(): string {
    switch (this.type) {
      case 'base':
        this.arrowIconColor = this.disabled ? GasColor.Color.Disabled : GasColor.Color.Brand;
        return 'gas-base';

      case 'primary':
        this.arrowIconColor = this.disabled ? GasColor.Color.Disabled : GasColor.Color.Brand;
        return 'gas-primary';

      case 'underline':
        return 'gas-underline';

      default: return 'gas-default';
    }
  }

  public toggle(): void {
    if (this.disabled) {
      return;
    }
    this.open = !this.open;
    this.openChange.emit(this.open);
  }

  public onPostfixIconClick($event: MouseEvent): void {
    $event.stopPropagation();
    this.postfixIconClicked.emit(this.section.name);
  }
}
